<template>
  <div>
    <v-dialog
      v-if="url"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <slot>View PDF</slot>
        </div>
      </template>
      <v-card>
        <div class="text-right">
          <v-btn text color="primary" @click="dialog = false" class="mx-3">
            <v-icon color="primary" class="mx-2">mdi-close</v-icon>
            {{ backBtnLabel }}</v-btn
          >
        </div>
        <v-container>
          <v-row>
            <v-col cols="12" lg="3" v-if="showCalcs && localShowCalcs">
              <div style="height: 2.5em">
                <v-btn
                  text
                  color="primary"
                  small
                  @click="localShowCalcs = false"
                  v-if="localShowCalcs"
                >
                  <v-icon small color="primary" class="mr-2"
                    >mdi-lightning-bolt</v-icon
                  >
                  Hide Quick Calcs</v-btn
                >
              </div>
              <quick-calcs :hideCloseButton="true"></quick-calcs>
              <v-textarea
                placeholder="scratch pad"
                background-color="yellow lighten-4"
                class="my-2"
                solo
              ></v-textarea>
            </v-col>
            <v-col cols="12" :lg="localShowCalcs ? 9 : 12">
              <div style="height: 2.5em">
                <v-btn
                  text
                  color="primary"
                  small
                  @click="localShowCalcs = true"
                  v-if="!localShowCalcs && showCalcs"
                >
                  <v-icon small color="primary" class="mr-2"
                    >mdi-lightning-bolt</v-icon
                  >
                  Show Quick Calcs
                </v-btn>
              </div>
              <iframe
                :src="viewerUrl + url + '&embedded=true'"
                class="pdfIframe"
              ></iframe>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "PdfViewer",
  components: {
    QuickCalcs: () => import("@/components/calcsStuff/QuickCalcs.vue"),
  },
  props: {
    // url: null,
    title: { type: String, default: "Fitting Guide" },
    backBtnLabel: { type: String, default: "Back To Listing" },
    showCalcs: { type: Boolean, default: false }, // can the calcs be shown?
    url: null,
  },
  data: function () {
    return {
      dialog: false,
      localShowCalcs: false, // toggles calcs display on/off
      viewerUrl: "https://docs.google.com/viewer?url=",
      //   url: "https://www.eyedock.com/images/rgp_media/renovation-multifocal_20230608.pdf",
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.pdfIframe {
  width: 95%;
  height: 90vh;
  /* margin: 1em; */
}
</style>
